import { Navigate, useLocation } from 'react-router';

/** Compatibilidad: el flujo de documento vive en `/home`. */
export default function CheckoutTipoDocumento() {
  const { state } = useLocation();
  return <Navigate to="/home" replace state={state} />;
}
